<div class="u-flex-full">
  <label>{{value?.name}} </label>
  <button class="close" *ngIf="value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear"
    (click)="clearRiskOwner()">
    <mat-icon>close</mat-icon>
  </button>

</div>